/**
 * Summary counts and per-email status table after Create Administrators submit.
 */

import { observer } from 'mobx-react-lite';

import Card from '../../../../../components/layouts/card/card';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import FontHeading4 from '../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../components/fonts/font-props';
import Table from '../../../../../components/table/table';
import TableRow from '../../../../../components/table/components/table-row/table-row';
import createAdministratorsStore from '../stores/create-administrators-store';

const RESULTS_COLUMNS = [
    { content: 'Email', width: { value: 1, type: 'fr' as const } },
    { content: 'Status', width: { value: 1, type: 'fr' as const } },
];

const CreateAdministratorsResultsCard: React.FC = observer(() => {
    const store = createAdministratorsStore;

    if (!store.result) {
        return null;
    }

    const { created, skipped, failed } = store.result;

    return (
        <div className="create-administrators-page__results-card">
            <Card isExpandable={false}>
                <FontHeading4>Results</FontHeading4>
                <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                    Created: {created.length}, Skipped: {skipped.length}, Failed: {failed.length}
                </FontBody2>
                <div className="create-administrators-page__table-wrapper">
                    <Table columns={RESULTS_COLUMNS}>
                        {created.map((administratorEmail, rowIndex) => (
                            <TableRow
                                key={`created-${administratorEmail}-${rowIndex}`}
                                name="created"
                                cells={[administratorEmail, 'Created']}
                            />
                        ))}
                        {skipped.map((administratorEmail, rowIndex) => (
                            <TableRow
                                key={`skipped-${administratorEmail}-${rowIndex}`}
                                name="skipped"
                                cells={[administratorEmail, 'Skipped (already exists)']}
                            />
                        ))}
                        {failed.map((administratorEmail, rowIndex) => (
                            <TableRow
                                key={`failed-${administratorEmail}-${rowIndex}`}
                                name="failed"
                                cells={[administratorEmail, 'Failed']}
                            />
                        ))}
                    </Table>
                </div>
            </Card>
        </div>
    );
});

export default CreateAdministratorsResultsCard;
